import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useTheme } from "@mui/material/styles";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

function InitialCapitalSetupPopup({ open, onClose, onOpenDepositModal }) {
  const theme = useTheme();
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        style: { 
          backgroundColor: theme.palette.background.default,
          boxShadow: 'none',
          maxWidth: '500px'
        }
      }}
    >
      <DialogContent>
        <Card sx={{ 
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: 'rgba(255, 152, 0, 0.1)',
          border: '2px solid #ff9800',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.14)',
        }}>
          <MDBox p={3} textAlign="center">
            <MDBox 
              display="flex" 
              justifyContent="center" 
              alignItems="center"
              mb={2}
            >
              <AccountBalanceWalletIcon 
                sx={{ 
                  fontSize: '2.5rem', 
                  color: '#ff9800'
                }} 
              />
            </MDBox>
            <MDTypography variant="h5" color="warning" fontWeight="bold" mb={2}>
              Please Set Your Initial Capital
            </MDTypography>
            <MDTypography variant="body2" mb={3}>
              Setting your initial capital allows us to accurately track your trading performance metrics and calculate returns on your investments.
            </MDTypography>
            <MDBox display="flex" justifyContent="space-between" mt={3}>
              <MDButton
                variant="text"
                color="dark"
                onClick={onClose}
                sx={{ width: '45%' }}
              >
                Later
              </MDButton>
              <MDButton
                variant="gradient"
                color="warning"
                onClick={() => {
                  onClose();
                  onOpenDepositModal();
                }}
                sx={{ width: '50%' }}
              >
                Set Initial Capital
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </DialogContent>
    </Dialog>
  );
}

export default InitialCapitalSetupPopup;